export const DRAFT_LEAGUE_AVG = {
  // Pitching
  fbVelo: 90.0,          // mph
  strikePct: 62.0,       // %
  whiffPct: 24.0,        // %
  // Hitting
  avg: 0.260,
  hardHitPct: 35.0,      // %
  barrelPct: 6.1,        // %
  chasePct: 28.0         // %
};
